import {
  Box,
  Grid,
  // LinearProgress,
  Typography,
} from '@material-ui/core';
// import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
// import clsx from 'clsx';
import jwtDecode from 'jwt-decode';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Logo from '../../components/Logo';
import { LoginJWT } from '../../components/authentication/login';
import useAuth from '../../hooks/useAuth';
import gtm from '../../lib/gtm';
import { useTranslation } from 'react-i18next';
import { PasswordResetAmplify } from 'src/components/authentication/password-reset';
import AnimatedSpheres from 'src/components/AnimatedSpheres';

// const useStyles = makeStyles<Theme>((theme: Theme) => createStyles({
//   wrapper: {
//     backgroundColor: '#E8EDF2',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     minHeight: '100vh',
//     border: 0,
//     borderRadius: 0,
//     [theme.breakpoints.down('md')]: {
//       minHeight: 'auto',
//       paddingTop: '2.5rem',
//     },
//   },
//   firstSectionWrapper: {
//     display: 'flex',
//     justifyContent: 'center',
//     background: 'url("/static/login_bg.png")',
//     backgroundRepeat: 'no-repeat',
//     backgroundSize: 'cover',
//     minHeight: '100vh',
//     alignItems: 'center',
//     flexDirection: 'column',
//     width: '100%',
//     [theme.breakpoints.down('md')]: {
//       background: 'none',
//       minHeight: '20vh',
//     },
//   },
//   card: {
//     backgroundColor: 'white',
//     border: 0,
//     borderRadius: '16px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     [theme.breakpoints.down('md')]: {
//       minHeight: 'auto',
//       paddingTop: '4.5rem',
//     },
//   },
//   desktopLogo: {
//     display: 'block',
//     background: 'white',
//     borderRadius: '50%',
//     padding: '10px 10px',
//     [theme.breakpoints.down('md')]: {
//       display: 'none',
//     },
//   },
//   mobileLogo: {
//     display: 'none',
//     [theme.breakpoints.down('md')]: {
//       display: 'block',
//     },
//   },
//   title: {
//     color: '#fff',
//     [theme.breakpoints.down('md')]: {
//       color: 'black',
//     },
//   },
//   subTitle: {
//     color: '#fff',
//     [theme.breakpoints.down('md')]: {
//       display: 'none',
//     },
//   },
//   leftHeroWrapper: {
//     display: 'flex',
//   },
//   leftHeroImage: {
//     maxWidth: '40%',
//     background: 'white',
//     objectFit: 'cover',
//     backgroundSize: 'cover',
//     backgroundRepeat: 'no-repeat',
//     minHeight: '100vh',
//     display: 'flex',
//     alignItems: 'center',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     [theme.breakpoints.down('md')]: {
//       display: 'none',
//     },
//   },
//   fullPageHero: {
//     maxWidth: '100%',
//   },
//   imagesWrapper: {
//     display: 'flex',
//   },
//   leftSideLogo: {
//     background: 'white',
//     display: 'flex',
//     justifyContent: 'center',
//     width: '50vw',
//     flexDirection: 'column',
//     alignItems: 'center',
//     [theme.breakpoints.down('md')]: {
//       width: '100vw',
//     },
//   },
//   textWhite: {
//     color: 'white',
//   },
//   logo: {
//     width: 150,
//     marginBottom: 24,
//   },
// }));
const Login: FC = () => {
  const { isAuthenticated, isFirstTime } = useAuth() as any;
  const [isAuthenticatedLocal, setIsAuthenticatedLocal] = useState<boolean>(false);
  const { t } = useTranslation(['toasts', 'login']);
  const isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    const currentTime = Date.now() / 1000;
    const decoded: any = jwtDecode(accessToken);
    return decoded.exp > currentTime;
  };

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);
  useEffect(() => {
    if (isValidToken && localStorage.getItem('accessToken')?.length > 0) {
      setIsAuthenticatedLocal(isAuthenticated);
    } else if (!isValidToken) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.reload();
    } else {
      setIsAuthenticatedLocal(true);
    }
  }, [isAuthenticatedLocal]);

  return (
    <>
      <Helmet>
        <title>{t('login:login_title')}</title>
      </Helmet>
      {isAuthenticatedLocal && (
        <Grid
          container
          sx={{
            minHeight: { xs: 'auto', md: '100vh' },
          }}
        >
          <Grid
            item
            xs={12}
            md={5}
            lg={5}
            xl={5}
            sx={{
              backgroundColor: 'red',
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
              justifyContent: { xs: 'center', md: 'flex-start' },
              p: { xs: 3, md: 6 },
              color: 'white',
              minHeight: { xs: '30vh', md: '100vh' },
              textAlign: { xs: 'center', md: 'left' },
              position: 'relative',
            }}
          >
            <Logo width={60} src='/static/logo_dark.png' />
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              pt: { xs: 4, md: '28%' },
              px: { xs: 0, md: 6 },
              maxWidth: { xs: '90%', md: 'unset' },
              zIndex: 1
            }}>
              <Typography variant='h2' sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: '1.6rem', md: '2.25rem' },
              }} >
                {t('login:login_left_heading')}
              </Typography>
              <Typography
                variant='subtitle1'
                sx={{
                  opacity: 0.9,
                  fontSize: { xs: '1rem', md: '1.2rem' },
                }}
              >
                {t('login:login_left_subtext')}
              </Typography>
            </Box>
            <AnimatedSpheres />
          </Grid>

          <Grid
            item
            xs={12}
            md={7}
            lg={7}
            xl={7}
            sx={{
              backgroundColor: '#E8EDF2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: { xs: 6, md: 0 },
              position: 'relative',
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 5, md: 6 },
                backgroundColor: 'transparent',
                display: 'flex',
                flexDirection: 'column',
                width: { xs: '100%', sm: 480, md: 564 },
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 3,
                }}
              >
                <Grid
                  container
                  sx={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: { xs: 1.5, md: 2 },
                  }}
                >
                  <Typography
                    color="textPrimary"
                    sx={{ fontSize: { xs: '1.6em', md: '2em' }, fontWeight: 600 }}
                    variant="h3"
                  >
                    {t('login:login_welcome_back')}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    sx={{
                      fontSize: { xs: '0.95em', md: '1em' }
                    }}
                  >
                    {t('login:login_log_into_your_account')}
                  </Typography>
                </Grid>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3,
                }}
              >
                {isFirstTime ? <PasswordResetAmplify /> : <LoginJWT />}
              </Box>
            </Box>

          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Login;
